import React, { lazy, useState} from "react";
import {useSearchParams} from "react-router-dom";
import { Button } from 'antd'
import styles from "@/pages/saleOperations/saleWorkBench/customerDetail/index.module.less";
import {queryClueDispatchFlag} from "@/services/callCenter";
import { SMessage } from "shj-components";
import { modalCallPendingSubmissionModelFn } from "@/pages/crm/callCenter/callManage/components/mainRight/components/Top/submitPending.tsx";
import { dispatchModalFn } from "@/pages/crm/callCenter/callManage/components/mainRight/components/Top/dispatch.tsx";
import { SubmitInvalidModalFn } from "@/pages/crm/callCenter/callManage/components/mainRight/components/Top/submitInvalid.tsx";
import { submitValidModalFn } from "@/pages/crm/callCenter/callManage/components/mainRight/components/Top/submitValid.tsx";
import { openAppointmentCallModal } from "@/pages/crm/callCenter/callManage/components/mainRight/components/Top/appointmentCallModal.tsx";
import { getAuth } from "@/utils/auth.ts";

const SaleModal = (props) => {
  const auth = getAuth()
  const [search] = useSearchParams()
  const clueId = search.get('clueId')
  const {
    detailState,
    trackDetail,
    reload = () => ({}),
    state = {},
    setState = () => ({}),
    buttonList = [],
    useBtnKey = false,
    disabledAuth = false,
  } = props
  const [view, setView] = useState(<></>)

  const onCloseModal = () => {
    setView(<></>)
  }

  const handleClick = async (key, desc) => { 
    setState({chooseButtonKey: key, chooseButtonDesc: desc})
    // 设计大师
    if (key === 'DESIGN_MASTER') {
      const View = await lazy(() => import('@/pages/crm/sellPlan/components/DesignMasterModal'));
      setView(
        <View
          orgId={detailState?.houseInfo?.orgId}
          reload={reload}
          editId={clueId ? trackDetail.id : detailState.templateNodeId}
          open={true}
          onClose={() => onCloseModal()}
        ></View>
      )
      return;
    }
    // 营销大师
    if (key === 'VIEW_CASE') {
      const View = await lazy(() => import('@/pages/crm/sellPlan/components/ProposalMasterModal'));
      setView(
        <View
          orgId={detailState?.houseInfo?.orgId}
          editId={clueId ? trackDetail.id : (detailState.templateNodeId || detailState.id)}
          open={true}
          onClose={() => onCloseModal()}
        ></View>
      )
      return;
    }
    // 预约到店
    if (key === 'APPOINTMENT_STORE') {
      if(detailState.status !== 'ORDINARY_MSG' && detailState.status !== 'TO_SHOP' && detailState.status !== 'DESIGN'){
        return SMessage.confirm({
          title: '请先对线索进行有效性判定',
          content: null,
        })
      }
      const View = await lazy(() => import('@/pages/crm/sellPlan/components/SubscribeModal'));
      setView(
        <View
          basicInfo={detailState}
          buttonKey={key}
          reload={reload}
          editId={detailState.id}
          open={true}
          onClose={() => onCloseModal()}
        ></View>
      )
      return;
    }
    // 呼叫待定
    if (key === 'CALL_PENDING') {
      modalCallPendingSubmissionModelFn({
        fn: () => {
          reload()
        },
        buttonKey: key,
        list: state.pendingCauseList || [],
        id: detailState?.id,
      })
      return;
    }
    // 派单
    if (key === 'DISPATCH') {
      dispatchModalFn({
        content: `确定更改${detailState.statusName}状态为派单状态?`,
        clueId: detailState?.id,
        buttonKey: key,
        fn: () => {
          reload()
        },
      })
      return;
    }
    // 呼叫无效
    if (key === 'CALL_INVALID') {
      SubmitInvalidModalFn({
        fn: () => {
          reload()
        },
        buttonKey: key,
        discardCauseList: state.discardCauseList,
        id: detailState?.id,
      })
      return;
    }
    // 呼叫有效
    if (key === 'CALL_VALID') {
      submitValidModalFn({
        content: `确定更改${detailState.statusName}状态为呼叫有效状态?`,
        clueId: detailState?.id,
        fn: () => {
          reload()
        },
      })
      return;
    }
    if (key === 'CALL_APPOINTMENT') {
      openAppointmentCallModal({
        clueId: detailState?.id,
        fn: () => {
          reload()
        },
      });
      return;
    }
    // 飞单按钮
    if (key === 'SUBMIT_LOST') {
      const View = await lazy(() => import('@/pages/crm/sellPlan/components/SubmitLostModal'));
      setView(
        <View
          buttonKey={key}
          reload={reload}
          editId={trackDetail.id}
          open={true}
          onClose={() => onCloseModal()}
        ></View>
      )
      return;
    }
    // 提交无效
    if (key === 'SUBMIT_INVALID') {
      const View = await lazy(() => import('@/pages/crm/sellPlan/components/SubmitInvalidModal'));
      setView(
        <View
          buttonKey={key}
          reload={reload}
          editId={detailState.id}
          open={true}
          onClose={() => onCloseModal()}
        ></View>
      )
      return;
    }
    // 提交待定
    if (key === 'SUBMIT_PENDING') {
      const View = await lazy(() => import('@/pages/crm/sellPlan/components/SubmitPendingModal'));
      setView(
        <View
          buttonKey={key}
          reload={reload}
          editId={detailState.id}
          open={true}
          onClose={() => onCloseModal()}
        ></View>
      )
      return;
    }
    // 提交有效
    if (key === 'SUBMIT_VALID') {
      const View = await lazy(() => import('@/pages/crm/sellPlan/components/SubmitEffectiveModal'));
      setView(
        <View
          basicInfo={detailState}
          buttonKey={key}
          reload={reload}
          editId={detailState.id}
          open={true}
          onClose={() => onCloseModal()}
        ></View>
      )
      return;
    }
    // 确认到店
    if (key === 'CONFIRM_TO_SHOP') {
      const View = await lazy(() => import('@/pages/crm/sellPlan/components/ConfirmModal'));
      setView(
        <View
          basicInfo={detailState}
          buttonKey={key}
          reload={reload}
          editId={detailState.id}
          open={true}
          onClose={() => onCloseModal()}
        ></View>
      )
      return;
    }
    // 确认场外见面 操作
    if (key === 'OUT_SIDE_CONFIRM_TO_SHOP') {
      const View = await lazy(() => import('@/pages/crm/sellPlan/components/ConfirmOutsideModal'));
      setView(
        <View
          basicInfo={detailState}
          buttonKey={key}
          reload={reload}
          editId={detailState.id}
          open={true}
          onClose={() => onCloseModal()}
        ></View>
      )
      return;
    }
    // 新增跟进
    if (key === 'ADD_RECORD') {
      const View = await lazy(() => import('@/pages/crm/sellPlan/components/AddNewFollowModal'));
      setView(
        <View
          buttonKey={key}
          reload={reload}
          editId={detailState.id}
          open={true}
          onClose={() => onCloseModal()}
        ></View>
      )
      return;
    }
    // 指定派单
    if (key === 'APPOINT_DISPATCH') {
      const View = await lazy(() => import('@/pages/clueManage/clueDetail/components/Modals/AppointDispatchModal'));
      setView(
        <View
          buttonKey={key}
          fn={reload}
          editId={detailState.id}
          open={true}
          trackPlanNodeId={clueId ? trackDetail.currentNodeId : detailState.currentNodeId}
          onClose={() => onCloseModal()}
        ></View>
      )
      return;
    }
    // 一键拨号
    if (key === 'DIALING') {
      const View = await lazy(() => import('@/pages/salesWorkbench/workbenchList/components/clueCallModal'));
      setView(
        <View
          open={true}
          clueId={detailState.id}
          fn={reload}
          onClose={() => onCloseModal()}
        ></View>
      )
      return;
    }
    // 设计部经理
    if (key === 'ASSIGN_DESIGNER_MNR') {
      setState({assignDesignDeptLoading: true})
      const res = await queryClueDispatchFlag(detailState.id)
      const isDispatchAll = res.every(item => item.dispatchFlag)
      if (isDispatchAll){
        setState({assignDesignDeptLoading: false})
        SMessage.confirm({
          title: '所有需求已分配设计部，无需再操作',
          content: null,
        })
        return;
      }
      const dispatchDesignDeptList = res?.filter(item => !item.dispatchFlag);
      setState({assignDesignDeptLoading: false})
      const View = await lazy(() => import('@/pages/clueManage/clueDetail/components/Modals/DispatchDesignDept'));
      setView(
        <View
          buttonKey={key}
          reload={reload}
          editId={detailState.id}
          dispatchDesignDeptList={dispatchDesignDeptList}
          open={true}
          onClose={() => onCloseModal()}
          trackPlanNodeId={detailState.currentNodeId}
        ></View>
      )
      return;
    }
    // 分配服务人员
    const View = await lazy(() => import('@/components/AllowcateWorkerModal'));
    setView(
      <View
        orgId={detailState?.houseInfo?.orgId}
        buttonKey={key}
        reload={reload}
        editId={detailState.id}
        open={true}
        onClose={() => onCloseModal()}
        trackPlanNodeId={clueId ? trackDetail.currentNodeId : detailState.currentNodeId}
        trackPlanId={trackDetail.id}
      ></View>
    )
  }

  return (
    <>
      <div className={styles.buttonBox}>
        {
          buttonList?.length ? buttonList?.map((button: any) => {
            const btnName = useBtnKey ? button.buttonDesc : button.sourceName
            const btnKey = useBtnKey ? button.buttonKey : button.sourceCode
            return (
                <Button
                    className={styles.operateButton}
                    disabled={detailState.isPublicSea || (disabledAuth ? false : !auth?.[btnKey])}
                    color="primary"
                    variant="outlined"
                    onClick={() => handleClick(btnKey, btnName)}
                    loading={btnKey === 'ASSIGN_DESIGNER_MNR' && state.assignDesignDeptLoading}
                >
                  {btnName}
                </Button>
            )
          }) : null
        }
      </div>
      <React.Suspense>
        {view}
      </React.Suspense>
    </>
  )
}

export default SaleModal